<template>
    <div class="affiliate-report-page">
    
        <div v-if="!isAuthenticated" class="password-overlay">
            <div class="password-modal">
                <h4 class="mb-3">🔒 Enter Password to View Report</h4>
                <input type="password" v-model="enteredPassword" @keyup.enter="verifyPassword" class="form-control mb-3" placeholder="Password" />
                <button @click="verifyPassword" class="btn btn-primary btn-block">
                        Access Report
                    </button>
                <p v-if="authError" class="text-danger mt-2">{{ authError }}</p>
            </div>
        </div>
    
        <div v-show="isAuthenticated">
    
            <div class="d-flex justify-content-between align-items-center mb-4">
                <h2 class="page-title">List User</h2>
            </div>
    
            <div class="report-card p-4">
    
                <div class="d-flex justify-content-between flex-wrap mb-3">
    
                    <div class="search-wrapper mb-2">
                        <i class="fa fa-search search-icon"></i>
                        <input v-model="searchQuery" @input="filterTable" type="text" placeholder="Search..." class="search-input" />
                    </div>
    
                  
    
                </div>
    
                <div class="table-responsive">
                    <table class="table table-border table-hover custom-table">
                        <thead style="background: var(--Gray-50, #F9FAFB);">
                            <tr>
                                <th></th>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Phone Number</th>
                                <th>User Type</th>
                                <th>Date</th>
                                <th></th>
                          
                            </tr>
                        </thead>
    
                        <tbody>
                            <tr v-for="item in paginatedData" :key="item.id">
                                <td>{{ item.Id }} </td>
                                <td>{{ item.Name }}</td>
                                <td>{{ item.Email }}</td>
                                <td>{{ item.Phone }}</td>
                                <td>{{ item.UserType }}</td>
                                <td>{{ item.CreatedTime | moment("DD/MM/YYYY HH:mm:ss") }}</td>
                                <td> <button 
    v-if="item.UserType == 'Affiliate'" 
    class="btn btn-sm btn-warning"
    @click="changeUserType(item)"
  >
    Change Type to Parent
  </button></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
    
                <div class="d-flex justify-content-between align-items-center mt-3 flex-wrap">
    
                    <small>
                                Showing {{ startRow }} to {{ endRow }} of {{ tableData.length }} entries
                              </small>
    
                    <ul class="pagination mb-0 mt-2">
                        <li class="page-item" :class="{ disabled: page === 1 }" @click="goPrev">
                            <a class="page-link">‹</a>
                        </li>
    
                        <li class="page-item" :class="{ active: page === 1 }" @click="goPage(1)">
                            <a class="page-link">1</a>
                        </li>
    
                        <li v-if="page > 3" class="page-item disabled">
                            <a class="page-link">...</a>
                        </li>
    
                        <li v-for="p in middlePages" :key="p" class="page-item" :class="{ active: page === p }" @click="goPage(p)">
                            <a class="page-link">{{ p }}</a>
                        </li>
    
                        <li v-if="page < totalPages - 2" class="page-item disabled">
                            <a class="page-link">...</a>
                        </li>
    
                        <li v-if="totalPages > 1" class="page-item" :class="{ active: page === totalPages }" @click="goPage(totalPages)">
                            <a class="page-link">{{ totalPages }}</a>
                        </li>
    
                        <li class="page-item" :class="{ disabled: page === totalPages }" @click="goNext">
                            <a class="page-link">›</a>
                        </li>
                    </ul>
    
                    <div>
                        Show
                        <select v-model="perPage" @change="updatePerPage" class="perPage-select">
                                  <option :value="10">10</option>
                                  <option :value="25">25</option>
                                  <option :value="50">50</option>
                                </select> entries
                    </div>
    
                </div>
            </div>
    
        </div>

        
    
    </div>
</template>
  
<script>
// Define the required password here (reusing the one provided previously)
const ACCESS_PASSWORD = "Flyhigh192077**";

export default {
    data() {
        return {
            // --- AUTHENTICATION DATA ---
            isAuthenticated: false,
            enteredPassword: '',
            authError: '',
            // ---------------------------

            searchQuery: "",
            selectedUserFilter: "Recent Users",
            selectedOrderFilter: "Recent Orders",
            selectedDateType: "bulanan",
            selectedMonth: "2025-11",

            monthList: [
                { label: "Jan 2025", value: "2025-01" },
                { label: "Feb 2025", value: "2025-02" },
                { label: "Mar 2025", value: "2025-03" },
                { label: "Apr 2025", value: "2025-04" },
                { label: "May 2025", value: "2025-05" },
                { label: "Jun 2025", value: "2025-06" },
                { label: "Jul 2025", value: "2025-07" },
                { label: "Aug 2025", value: "2025-08" },
                { label: "Sep 2025", value: "2025-09" },
                { label: "Oct 2025", value: "2025-10" },
                { label: "Nov 2025", value: "2025-11" },
                { label: "Dec 2025", value: "2025-12" }
            ],

            tableData: [],
            originalData: [],

            page: 1,
            perPage: 10,
        };
    },

    computed: {
        totalPages() {
            return Math.ceil(this.tableData.length / this.perPage);
        },
        paginatedData() {
            const start = (this.page - 1) * this.perPage;
            return this.tableData.slice(start, start + this.perPage);
        },
        startRow() {
            return (this.page - 1) * this.perPage + 1;
        },
        endRow() {
            return Math.min(this.page * this.perPage, this.tableData.length);
        },
        middlePages() {
            const pages = [];

            for (let i = this.page - 1; i <= this.page + 1; i++) {
                if (i > 1 && i < this.totalPages) {
                    pages.push(i);
                }
            }

            return pages;
        }
    },
    async mounted() {
        // 🔥 Check if user was authenticated earlier
        let savedAuth = localStorage.getItem("affiliateReportAuth");

        if (savedAuth === "true") {
            this.isAuthenticated = true;
            this.GetListUser(); // Auto-load data
            return;
        }

        // Still need login check for app
        let isAuth = await this.UserAuth();
        if (!isAuth) this.GoToLogin();
    },


    methods: {
        // --- NEW METHOD: PASSWORD CHECK ---
        verifyPassword() {
            this.authError = '';

            if (this.enteredPassword === ACCESS_PASSWORD) {
                this.isAuthenticated = true;
                this.enteredPassword = '';

                // 🔥 Save auth state so refresh won't require re-entering password
                localStorage.setItem("affiliateReportAuth", "true");

                this.GetListUser();
            } else {
                this.authError = 'Incorrect password. Please try again.';
            }
        },
        // ----------------------------------

        filterTable() {
            this.filterAll();
        },
        filterAll() {
            if (!this.originalData) return;

            let data = [...this.originalData];

            // -------------------------------
            // 2. SEARCH FILTER
            // -------------------------------
            if (this.searchQuery.trim() !== "") {
                let q = this.searchQuery.toLowerCase();
                data = data.filter(x =>
                    (x.Name || "").toLowerCase().includes(q) ||
                    (x.Email || "").toLowerCase().includes(q) ||
                    (x.Phone || "").toLowerCase().includes(q)
                );
            }

     



            // Update the table data and reset pagination
            this.tableData = data;
            this.page = 1;
        },

        handleFilterChange() {
            this.filterAll();
        },

        goPrev() {
            if (this.page > 1) this.page--;
        },
        goNext() {
            if (this.page < this.totalPages) this.page++;
        },
        goPage(n) {
            this.page = n;
        },
        updatePerPage() {
            this.page = 1;
        },
        parseAmount(amountString) {
            if (typeof amountString !== 'string') return 0;
            const match = amountString.match(/(\d[\d\s,.]*)/);
            if (match) {
                return parseFloat(match[0].replace(/[^0-9.]/g, '')) || 0;
            }
            return 0;
        },

        async GetListUser() {
            // Only proceed if authenticated
            if (!this.isAuthenticated) return;

            try {
                this.isLoading = true;
                const response = await this.$API.get(this.$GetListUser);

                if (response.status === 200 && response.data) {
                    this.isLoading = false;

                    // Filter data for AffiliateTypeId 1 (Affiliate Staff)
                    const filteredData = response.data;

                    this.originalData = filteredData;
                    this.filterAll();
                }
            } catch (err) {
                console.error("Error loading report:", err);
            }
        },

        GoToLogin() {
            let path = this.$router.currentRoute.path;
            if (path.toLowerCase() != "/login") {
                this.$router.push({
                    path: "/login",
                    query: { targetUrl: this.$router.currentRoute.fullPath }
                });
            }
        },
        async changeUserType(user) {
        try {
            const confirmChange = confirm(
                `Are you sure you want to change ${user.Name}'s type from Affiliate to Parent?`
            );
            if (!confirmChange) return;

            // Call the API
            const response = await this.$API.post(this.$UpdateUserType, {
                userId: user.Id
            });

            // Parse JSON response
            const res = typeof response.data === 'string' ? JSON.parse(response.data) : response.data;

            if (res.success) {
                // Update the table locally
                user.UserType = 'Parent';
                alert(res.message);
            } else {
                alert('Failed: ' + res.message);
            }
        } catch (err) {
            console.error('API Error:', err);
            alert('Error updating user type.');
        }
    }

      
    }
};
</script>
  
<style scoped>
.btn-primary {
    background-color: #2563eb;
    border-color: #2563eb;
    color: white;
    font-weight: 500;
}

.affiliate-report-page {
    background: #f7f7f7;
    min-height: 100vh;
}

.page-title {
    font-weight: 600;
}

.report-card {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 3px 12px rgba(0, 0, 0, 0.05);
}

/* SEARCH BAR */

.search-wrapper {
    position: relative;
}

.search-input {
    padding-left: 35px;
    height: 40px;
    border-radius: 8px;
    border: 1px solid #ddd;
}

.search-icon {
    position: absolute;
    top: 10px;
    left: 12px;
    font-size: 14px;
    color: #6c757d;
}

/* FILTER SELECT */

.filter-select {
    height: 40px;
    margin-left: 10px;
    border-radius: 8px;
    border: 1px solid #ddd;
    padding: 0 10px;
}

/* STATUS BADGES */

.status-badge {
    padding: 4px 10px;
    border-radius: 10px;
    font-size: 12px;
    font-weight: 600;
}

.status-badge.yes {
    background: #d1fae5;
    color: #059669;
}

.status-badge.no {
    background: #ffe4e6;
    color: #e11d48;
}

/* TABLE */

.custom-table th {
    font-size: 14px;
    color: #6c757d;
}

/* PAGINATION */

.pagination .page-item.active .page-link {
    background: #2563eb;
    border-color: #2563eb;
    color: #fff;
}

.page-link {
    border-radius: 6px !important;
}

/* Per-page select */

.perPage-select {
    padding: 4px 10px;
    border-radius: 8px;
    border: 1px solid #ddd;
}

/* --- NEW STYLES FOR PASSWORD POPUP --- */

.password-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1050;
    /* Above other content */
}

.password-modal {
    background: white;
    padding: 30px;
    border-radius: 8px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
    width: 100%;
    max-width: 400px;
    text-align: center;
}

.text-danger {
    color: #dc3545;
}

/* -------------------------------------- */
</style>